<script setup lang="ts">
import { VIEW_ITEM_LIST_IDS, VIEW_ITEM_LIST_NAMES } from "~/utils/analytics/viewItemList"
</script>

<template>
  <GAList
    :id="VIEW_ITEM_LIST_IDS.BRAND_BANNER"
    :name="VIEW_ITEM_LIST_NAMES.HOME_PAGE"
    entity="carouselBrandBanner"
  >
    <slot />
  </GAList>
</template>
